import axios from 'axios';

import { UserSubscription } from '@app-types/subscription.type';
import { buildEndpoint, getAuthToken } from '@services/service';

const BASE_URL = process.env.REACT_APP_SUBSCRIPTIONS_URL as string;

const getUserSubscriptions = async (
    userId: number
): Promise<UserSubscription[] | null> => {
    try {
        const url = buildEndpoint(
            BASE_URL,
            `api/admin/v2/users/${userId}/subscriptions`
        );
        const response = await axios.get(url, {
            headers: { Authorization: getAuthToken() },
        });

        return response.data;
    } catch (err) {
        console.error('Error getting user subscriptions', err);
        return null;
    }
};

export { getUserSubscriptions };
